<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Customer Account Enquiry</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CustomerAccountEnquiryForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import CustomerAccountEnquiryForm
  from "../../components/Kleyton/Forms/FundsTransfer/Enquiry/CustomerAccountEnquiryForm";

export default {
  name: "CustomerAccountEnquiry",
  page: {
    title: "Funds Transfer",
    meta: [{ name: "Funds Transfer", content: window.__env.app.description }]
  },
  components: {
    CustomerAccountEnquiryForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "FundsTransfer",
      title: "Transfer Funds",
      items: [
        {
          text: "Funds Transfer",
          href: "/"
        },
        {
          text: "Transfer Funds",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
